import { Form, Input, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Authorization from "../../../../component/Authorization";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import MUploadImage from "../../../../component/UploadImage";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { Category, CategoryUI } from "../entity/category.model";
import { categoryService } from "../service/category.service";
import { Entity } from "../../shared/shared.model";
import { entityService } from "../../shared/service/entity.service";

export default function EditCategory() {
  const { dispatch } = useContext(SpinContext);
  const { Option } = Select;
  let { categoryId } = useParams();
  let navigate = useNavigate();
  const [category, setCategory] = useState<CategoryUI>();
  const [categories, setCategories] = useState<Entity[]>([]);

  useEffect(() => {
    if (categoryId) {
      dispatch({ type: spinActions.BLOCK });

      categoryService
        .getCategory(categoryId)
        .then((_category: Category) => {
          dispatch({ type: spinActions.UNBLOCK });
          console.log(_category, "_category");
          helper
            .getImage("/public" + "/" + _category.imagePath)
            .then((file) => {
              setCategory({
                ..._category,
                file: file,
              });
            });
        })

        .catch(() => {
          dispatch({ type: spinActions.UNBLOCK });
        });
    } else {
      setCategory({
        uuid: "",
        imagePath: "",
        category1Cuuid: "",
      });
    }

    entityService.getCategories().then((_categories) => {
      _categories.sort((a, b) => a.name.localeCompare(b.name));
      setCategories(_categories);
    });
    return () => {
      setCategories([]);

      setCategory(undefined);
    };
  }, [categoryId]);

  const onFinish = async (values: CategoryUI) => {
    const formData = new FormData();
    formData.append("file", values.file);
    const categoryDto = {
      category1Cuuid: values.category1Cuuid,
      category1Cname: categories.find((b) => b.uuid === values.category1Cuuid)
        ?.name,
      ...(categoryId && { uuid: categoryId }),
    };
    formData.append(
      "categoryDto",
      new Blob([JSON.stringify(categoryDto)], { type: "application/json" })
    );

    if (category) {
      try {
        if (categoryId) {
          await categoryService.editCategory(formData);
        } else {
          await categoryService.addCategory(formData);
        }
        dialog.success("Төрөл амжилттай шинэчлэгдлээ.");
        navigate("/category");
      } catch (e) {
        console.error(e);

        return;
      }
    }
  };
  return (
    <>
      <MPageHeader crumbs={["Төрөл", category?.uuid ?? ""]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h5 className="card-title">
              {categoryId ? "Төрөл засах" : "Төрөл нэмэх"}{" "}
            </h5>
          </div>
          <div className="card-body">
            {category && (
              <fieldset disabled={!helper.hasRoles(["customer-full"])}>
                <Form initialValues={category} onFinish={onFinish}>
                  <div className="form-group">
                    <label>
                      Зураг<span className="text-danger">*</span>
                    </label>

                    <Form.Item
                      name="file"
                      rules={[
                        {
                          required: true,
                          message: "Зураг оруулна уу.",
                        },
                      ]}
                    >
                      <MUploadImage
                        disabled={!helper.hasRoles(["customer-full"]) || categoryId !== undefined}
                      />
                    </Form.Item>
                  </div>
                  <div className="form-group">
                    <label>UUID</label>
                    <Form.Item name="uuid">
                      <Input readOnly={true} className="form-control" />
                    </Form.Item>
                  </div>
                  <div className="form-group">
                    <label>Төрөл </label>
                    <Form.Item
                      name="category1Cuuid"
                      rules={[
                        {
                          required: true,
                          message: "Төрөл сонгоно уу.",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Төрөл сонгох"
                        disabled={!helper.hasRoles(["customer-full"])}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option!.children as unknown as string)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {categories.map((category) => (
                          <Option value={category.uuid} key={category.uuid}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>

                  <Authorization roles={["customer-full"]}>
                    <div className="text-right">
                      <button type="submit" className="btn btn-primary">
                        Хадгалах <i className="icon-floppy-disk ml-2" />
                      </button>
                    </div>
                  </Authorization>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
